
import Component from 'vue-class-component'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'
import {Organisation} from '@/models/organisation'
import {Extra} from '@/models/user'
import { State } from 'vuex-class'
import {User as Storeuser} from '@/store/index'

@Component({
  components: {},
})
export default class LicenceForm extends Vue {
  @State public readonly user: Storeuser
  @Prop() private readonly licences!: string[]
  @Prop() private readonly org!: Organisation | Extra

  private mounted() {
  }

}
